import gcLogo from '../assets/gclogo.png';

interface SeekerHeaderProps {
  showLogin?: boolean;
  onLoginClick?: () => void;
}

export function SeekerHeader({ showLogin = false, onLoginClick }: SeekerHeaderProps) {
  return (
    <header className="flex items-center justify-between px-[72px] h-[87px] bg-[#2C2731] border-b border-[rgba(204,204,204,0.6)]">
      <div className="flex items-center">
        <a href={(window as any).__ENV__?.SITE_URL || 'https://guidescollective.com'}>
          <img src={gcLogo} alt="Guides Collective" className="h-9 w-auto" />
        </a>
      </div>
      {showLogin && (
        <button
          onClick={onLoginClick}
          className="px-6 py-2 bg-[#FFFCEF] text-[#2C2731] border border-[#FFFCEF] rounded-full hover:bg-transparent hover:text-[#FFFCEF] transition-colors"
        >
          Log In
        </button>
      )}
    </header>
  );
}
